import TheoryTaskForm from './theory-task-form'

export default TheoryTaskForm
